import { atomWithQuery } from 'jotai-tanstack-query'
import { atomFamily } from 'jotai/utils'
import { fetchAllSubTabs, fetchSubTabsByMainTopic } from '../services/strapiServices'
import { GuideSubTab } from '../components/Guide/types/guide.types'

export const subTopicsAtomFamily = atomFamily((mainTopicSlug: string | undefined) =>
  atomWithQuery<GuideSubTab[]>((_get) => ({
    queryKey: ['subTopics', mainTopicSlug],
    queryFn: () => {
      if (!mainTopicSlug) {
        throw new Error('subTopicsAtomFamily called without a slug')
      }
      return fetchSubTabsByMainTopic(mainTopicSlug)
    },
    enabled: Boolean(mainTopicSlug),
  })),
)

export const allSubTabsAtom = atomWithQuery<GuideSubTab[]>((_get) => ({
  queryKey: ['allSubTabs'],
  queryFn: () => fetchAllSubTabs(),
}))
